<template>
    <generic-crud :service='service' labelNome='nome_categoria'></generic-crud>
</template>
<script>

import GenericCrud from '../components/GenericCrud'
import CategoriaService from '../services/categoria-service'

export default {

  components: {
    GenericCrud
  },
  data () {
    return {
      service: CategoriaService
    }
  }

}
</script>

